import React from 'react'

export default function HeaderInput() {
  return (
    <div></div>
  )
}
